import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "pr-x2" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-12" }

import {
    BaseProductItem,
    ItemType,
    ItemMessageType,
    ModuleSofaConfigurationProductItem,
    PickAndPackProductItem,
} from '@/b2b/shared/api/server-apis';
import { computed } from 'vue';
import ItemMessages from '@/b2b/shared/checkout/ui/ItemMessages.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutItem',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
    item: ModuleSofaConfigurationProductItem | PickAndPackProductItem | BaseProductItem;
}



const labels = useBlockLabels();

const isModuleSofaItem = computed(() => {
    return props.item.type === ItemType.ModuleSofa || props.item.type === ItemType.ModuleConfiguration;
});

const itemMessages = computed(() => {
    return [...props.item.primaryItemMessages, ...props.item.secondaryItemMessages];
});


return (_ctx: any,_cache: any) => {
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(isModuleSofaItem))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.item.image,
            class: "w-75"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createBlock(_component_ProductImage, {
            key: 1,
            sku: __props.item.sku,
            alt: __props.item.name,
            "aspect-ratio": 4/3,
            "width-on-screen": 1,
            class: "w-75"
          }, null, 8, ["sku", "alt"]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, _toDisplayString(__props.item.name), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(labels).deliverableItemsItemCount, { quantity: __props.item.quantity })), 1),
      _createVNode(ItemMessages, {
        messages: _unref(itemMessages),
        type: _unref(ItemMessageType).CheckOut,
        class: "text-12"
      }, null, 8, ["messages", "type"]),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})